/* eslint-disable import/prefer-default-export */
import styled from '@emotion/styled';
import { Card } from '@mui/material';

export const CardContainer = styled(Card)`
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  max-width: 345px;
  border-radius: 15px;
`;
